export default __webpack_public_path__ + "how-to.3cfd44.jpg";